import { useQuery } from '@tanstack/react-query';
import { getInterventionReport, listInterventionReports } from './api';
import type { InterventionReportFilters } from './types';

export const interventionReportKeys = {
  all: ['intervention-reports'] as const,
  list: (accountId: string, filters: InterventionReportFilters) => (
    [...interventionReportKeys.all, 'list', accountId, filters] as const
  ),
  detail: (accountId: string, reportId: string) => (
    [...interventionReportKeys.all, 'detail', accountId, reportId] as const
  ),
};

export function useInterventionReports(accountId: string, filters: InterventionReportFilters) {
  return useQuery({
    queryKey: interventionReportKeys.list(accountId, filters),
    queryFn: () => listInterventionReports(accountId, filters),
    enabled: Boolean(accountId),
  });
}

export function useInterventionReport(accountId: string, reportId: string | null) {
  return useQuery({
    queryKey: interventionReportKeys.detail(accountId, reportId || ''),
    queryFn: () => getInterventionReport(accountId, reportId!),
    enabled: Boolean(accountId && reportId),
  });
}
